export default __webpack_public_path__ + "4f8b85988eed5a289f5b79edbba1f8fa.png";